import { SettingsBusinessesTable } from "./SettingsBusinessesTable";
import { useGetBusinesses } from "@/hooks/useGetBusinesses";
import * as Sentry from "@sentry/react";
import { Skeleton } from "@/components/ui/skeleton";
import { SettingsPageHeader } from "../components/SettingsPageHeader";
import { useT } from "@/i18n";

export function SettingsBusinesses() {
  const businesses = useGetBusinesses();
  const { t } = useT();

  if (businesses.isLoading) {
    return (
      <div className="flex min-h-0 flex-1 flex-col">
        <SettingsPageHeader title={t("settings.businesses")} />
        <div className="px-3 pb-4 md:px-4">
          <div
            aria-busy="true"
            className="surface-card flex flex-col gap-3 bg-card p-4 text-card-foreground"
          >
            {Array.from({ length: 5 }, (_, index) => (
              <div key={index} className="flex items-center gap-3">
                <Skeleton className="size-8 shrink-0 rounded-full" />
                <Skeleton className="h-4 flex-1" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (!businesses.isSuccess) {
    Sentry.captureException(businesses.error, {
      extra: {
        message: "businesses.isSuccess is false",
        extra: {
          error: businesses.error,
        },
      },
    });
    // TODO(yannis): show something
    return null;
  }

  return <SettingsBusinessesTable businesses={businesses.data} />;
}
